import { IConnectBtcResponse, IInjectedBtcProvider } from '../../types';
import { getInjectedXverseBtcProvider } from './getInjectedBtcProvider';

const FIRST_WALLET = 0;
// https://docs.xverse.app/sats-connect/wallet-events
const XVERSE_ACCOUNT_CHANGE_EVENT = 'accountChange';

const XVERSE_LISTENERS: Record<string, () => void> = {};

/**
 * Connect to the Xverse wallet.
 *
 * @docs https://docs.xverse.app/sats-connect/connecting-to-the-wallet/getaccounts
 *
 * @returns Standard response with the address and public key.
 */
export async function connectXverse(): Promise<IConnectBtcResponse> {
  const provider = getInjectedXverseBtcProvider();

  const response = await provider.request('getAccounts', {
    purposes: ['payment'],
    message: 'Connect Lombard APP to Xverse wallet.',
  });

  const injectedProvider: IInjectedBtcProvider = {
    ...provider,
    onAccountChange: (callback: (args: any) => void) => {
      // Store the listener in the XVERSE_LISTENERS object to remove it later
      const listener = provider.addListener(
        XVERSE_ACCOUNT_CHANGE_EVENT,
        callback,
      );
      XVERSE_LISTENERS[response.result[FIRST_WALLET].address] = listener;
    },
    removeAccountChangeListener: () => {
      const removeListenerFn =
        XVERSE_LISTENERS[response.result[FIRST_WALLET].address];
      if (removeListenerFn) {
        removeListenerFn();
      }
    },
  };

  return {
    address: response.result[FIRST_WALLET].address,
    publicKey: response.result[FIRST_WALLET].publicKey,
    injectedProvider,
  };
}
